import React, { useState } from 'react';
import { PencilIcon, ArchiveBoxArrowDownIcon, ArrowUturnLeftIcon } from '@heroicons/react/24/solid';
import { formatDate } from '../../../utils/dateUtils';
import { toast } from 'react-toastify';
import OrderService from '../../order/OrderService';

const OrderDetail = ({ order, index, setOrder, refreshPendingOrder, openConfirm, isSelectMode, handleSelectOrder, selectedOrders }) => {
  const [confirmingRevert, setConfirmingRevert] = useState(false);
  const [reverting, setReverting] = useState(false);

  const hasWebsiteFee = Number(order.websiteTransactionFee) > 0 || Number(order.websiteAdditionalRate) > 0;

  // ส่งตรวจ status badge — managed from the Edit Order panel (pencil → checkbox → Update)
  const anshinFee = Array.isArray(order.extraJpFees)
    ? order.extraJpFees.find(f => f.type === 'mercari_anshin')
    : null;

  const handleEditClick = () => {
    console.log(order)
    setOrder(order)
  }

  const handleArchiveClick = () => {
    setOrder(order)
    openConfirm()
  }

  const handleSelectClick = () => {
    handleSelectOrder(order);
  };

  const handleRevertClick = () => setConfirmingRevert(true);
  const handleRevertCancel = () => setConfirmingRevert(false);

  const handleRevertConfirm = async () => {
    setReverting(true);
    try {
      await OrderService.revertWebsiteFee(order.id);
      toast.success('ลบค่าบริการเว็บไซต์เรียบร้อยแล้ว');
      setConfirmingRevert(false);
      if (refreshPendingOrder) refreshPendingOrder();
    } catch (err) {
      toast.error('เกิดข้อผิดพลาด: ' + (err.response?.data?.message || err.message));
    } finally {
      setReverting(false);
    }
  };

    return (
        <div>
            <div className='grid grid-cols-7 gap-x-5 py-2 border-b'>
                <div className='col-span-2 flex'>
                    <span className='bg-red-300 w-8 h-8 rounded-full flex items-center justify-center'>{index + 1}</span>
                    <img className='ml-2 w-32 h-32 object-contain' src={order.imageUrl} alt="Order"/>
                </div>
                {order &&
                  <div className='col-span-4 truncate'>
                    <a href={order.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{order.url}</a>
                    <p>{order.smileNameInput}</p>
                    <p>
                      {order.amount}
                      {order.deliveryFeeJp !== null ? (
                          <span> + {order.deliveryFeeJp}</span>
                      ) : (
                          order.isCod && <span className='text-red-500'> {"(เก็บปลายทาง)"}</span>
                      )}
                    </p>
                    <p>{formatDate(order.orderDate)}</p>
                    {anshinFee && (
                      <span className='inline-block mt-1 text-sm text-green-700 font-medium'>
                        ✓ ส่งตรวจ{Number(anshinFee.amountJpy) > 0 ? ` (¥${anshinFee.amountJpy})` : ' (ฟรี)'}
                      </span>
                    )}
                  </div>
                }
                <div className='col-span-1 flex space-x-2 items-start'>
                    {isSelectMode ? (
                      <input
                        type="checkbox"
                        checked={selectedOrders.includes(order)}
                        onChange={handleSelectClick}
                      />
                    ) : (
                      <>
                        <PencilIcon onClick={handleEditClick} className="h-6 w-6 text-gray-700 hover:text-gray-900 cursor-pointer" />
                        <ArchiveBoxArrowDownIcon onClick={handleArchiveClick} className="h-6 w-6 text-gray-700 hover:text-gray-900 cursor-pointer" />
                        {hasWebsiteFee && (
                          <ArrowUturnLeftIcon
                            onClick={handleRevertClick}
                            title="ยกเลิกค่าบริการเว็บไซต์"
                            className="h-6 w-6 text-orange-500 hover:text-orange-700 cursor-pointer"
                          />
                        )}
                      </>
                    )}
                </div>
            </div>

            {confirmingRevert && (
              <div className='mt-2 p-3 bg-orange-50 border border-orange-300 rounded text-sm'>
                <p className='font-medium text-orange-800'>ยืนยันการยกเลิกค่าบริการเว็บไซต์?</p>
                <p className='text-orange-700 text-xs mt-1'>
                  ค่าบริการเว็บไซต์ {Number(order.websiteTransactionFee) > 0 ? `${Number(order.websiteTransactionFee).toFixed(2)} ฿` : ''}
                  {Number(order.websiteAdditionalRate) > 0 ? ` (rate +${Number(order.websiteAdditionalRate)})` : ''} จะถูกลบออกจากออเดอร์นี้
                </p>
                <div className='flex gap-2 mt-2'>
                  <button
                    onClick={handleRevertConfirm}
                    disabled={reverting}
                    className='px-3 py-1 bg-orange-600 text-white rounded text-xs hover:bg-orange-700 disabled:opacity-50'
                  >
                    {reverting ? 'กำลังดำเนินการ...' : 'ยืนยัน'}
                  </button>
                  <button
                    onClick={handleRevertCancel}
                    disabled={reverting}
                    className='px-3 py-1 bg-gray-200 text-gray-700 rounded text-xs hover:bg-gray-300'
                  >
                    ยกเลิก
                  </button>
                </div>
              </div>
            )}
        </div>
    )
}

export default OrderDetail;
